export const filterItems = (searchItems, search, selectedDepartments) => {
	return searchItems.filter(item => {
		let hasSkillLevelWithSearch = search
			? item.skillLevels.some(skill =>
					skill.description
						?.toLowerCase()
						.includes(search?.toLowerCase())
			  )
			: false;
		let hasNameWithSearch = search
			? (item.firstName + ' ' + item.lastName)
					.toLowerCase()
					.includes(search?.toLowerCase())
			: false;
		let hasPositionsWithIdsSelected = selectedDepartments?.length
			? selectedDepartments.every(element =>
					item.positions.some(
						position =>
							position.positionAbbreviation?.toLowerCase() ===
							element.toLowerCase()
					)
			  )
			: false;
		if (search && selectedDepartments?.length) {
			return (
				(hasSkillLevelWithSearch || hasNameWithSearch) &&
				hasPositionsWithIdsSelected
			);
		}
		return (
			hasSkillLevelWithSearch ||
			hasNameWithSearch ||
			hasPositionsWithIdsSelected
		);
	});
};
